import angular from "../img/angular.svg";
import aurelia from "../img/aurelia.svg";
import backbone from "../img/backbone.svg";
import ember from "../img/ember.svg";
import react from "../img/react.svg";
import vue from "../img/vue.svg";

const IMAGES = [
  {
    name: 'angular',
    svg: angular,
  },
  {
    name: 'aurelia',
    svg: aurelia,
  },
  {
    name: 'backbone',
    svg: backbone,
  },
  {
    name: 'ember',
    svg: ember,
  },
  {
    name: 'react',
    svg: react,
  },
  {
    name: 'vue',
    svg: vue,
  },
];

export default IMAGES;
